import { Routes } from '@angular/router';

import * as fromStore from './store';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MuseumCollectionDetailGuard, MuseumCollectionMetaGuard, MuseumCollectionsGuard } from './guards';
import { MuseumCollectionComponent } from './containers/museum-collection/museum-collection.component';

export const routes: Routes = [
  {
    path: ':collectionId/:target',
    component: MuseumCollectionComponent,
    canActivate: [MuseumCollectionsGuard, MuseumCollectionMetaGuard],
    providers: [
      provideState(fromStore.featureKey, fromStore.reducers, {
        metaReducers: fromStore.metaReducers,
      }),
      provideEffects(fromStore.effects),
    ],
  },
];
